import { WarningFill16 } from 'ui/icons/aurora/16px/WarningFill16';
import { MODAL_SIZES, Modal, ModalFooter, ModalHeader } from 'ui/modal';
import { MODAL_CONTENT } from 'modules/anonymousUserTracking/constants';
import { DestructiveButton, PrimaryButton } from 'ui/button';
import { AnonUserCriteria } from 'modules/graphql/types/GraphQLAnonymousCriteria';
import { useToggleAnonCriteriaActive } from 'modules/anonymousUserTracking/hooks/useToggleAnonCriteriaActive';
import { colors } from 'ui/theme/colors';
import { ModalHeaderWrapper, StyledModalBody } from '../AnonymousUserTracking.styled';

const {
  TOGGLE_ACTIVE_MODAL_HEADER,
  TOGGLE_INACTIVE_MODAL_HEADER,
  TOGGLE_ACTIVE_MODAL_BODY,
  TOGGLE_INACTIVE_MODAL_BODY,
  TOGGLE_ACTIVE_BUTTON_LABEL,
  TOGGLE_INACTIVE_BUTTON_LABEL,
} = MODAL_CONTENT;

export const ToggleActiveModal = ({
  activating,
  onClose,
  criteria,
  onSuccess,
}: {
  activating: boolean;
  onClose: () => void;
  criteria: AnonUserCriteria;
  onSuccess?: () => void;
}) => {
  const ButtonCmp = activating ? PrimaryButton : DestructiveButton;
  const { toggleCriteriaActive } = useToggleAnonCriteriaActive(criteria);

  const handleConfirm = () => {
    toggleCriteriaActive(activating, () => {
      onSuccess?.();
      onClose();
    });
  };

  return (
    <Modal size={MODAL_SIZES.SMALL} id="criteria-activate-modal" isModalOpen onClose={onClose}>
      <ModalHeader>
        <ModalHeaderWrapper>
          <WarningFill16 color={colors.iconWarning} />
          {activating ? TOGGLE_ACTIVE_MODAL_HEADER : TOGGLE_INACTIVE_MODAL_HEADER}
        </ModalHeaderWrapper>
      </ModalHeader>
      <StyledModalBody data-test="toggle-activate-modal-body">
        {activating
          ? TOGGLE_ACTIVE_MODAL_BODY(criteria.fields.name)
          : TOGGLE_INACTIVE_MODAL_BODY(criteria.fields.name)}
      </StyledModalBody>
      <ModalFooter>
        <ButtonCmp onClick={handleConfirm}>
          {activating ? TOGGLE_ACTIVE_BUTTON_LABEL : TOGGLE_INACTIVE_BUTTON_LABEL}
        </ButtonCmp>
      </ModalFooter>
    </Modal>
  );
};
